<template>
  <v-dialog
    :value="value"
    max-width="420"
    :persistent="loading"
    @input="handleDialogInput">
    <v-card>
      <v-toolbar dark color="error">
        <v-toolbar-title class="font-weight-bold">
          {{ dialogTitle }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn @click="handleCancel" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="py-6">
        <div class="text-subtitle-1 text-center mb-0">
          {{ dialogMessage }}
        </div>
        <v-alert v-if="error" type="error" outlined dense class="mt-4">
          {{ error }}
        </v-alert>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn text :disabled="cancelDisabled" @click="handleCancel">
          {{ cancelText }}
        </v-btn>
        <v-spacer />
        <v-btn
          color="error"
          depressed
          class="ml-2 text-none"
          :loading="loading"
          :disabled="confirmDisabled"
          @click="handleConfirm">
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PromotionDeleteDialog',
  props: {
    value: { type: Boolean, default: false },
    promotion: { type: Object, default: () => ({}) },
    error: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },
  computed: {
    dialogTitle() {
      return this.$t('entities.promotions.card.deleteDialogTitle')
    },
    dialogMessage() {
      const name = this.promotion?.name
      return this.$t('entities.promotions.card.deleteConfirmation', { name })
    },
    confirmText() {
      return this.$t('miscellaneous.delete')
    },
    cancelText() {
      return this.$t('miscellaneous.cancel')
    },
    confirmDisabled() {
      return this.loading
    },
    cancelDisabled() {
      return this.loading
    },
  },
  methods: {
    emitInput(value) {
      this.$emit('input', value)
    },
    handleDialogInput(value) {
      if (this.loading) {
        this.emitInput(true)
        return
      }
      this.emitInput(value)
      if (!value) {
        this.$emit('cancel')
      }
    },
    handleCancel() {
      if (this.cancelDisabled) return
      this.emitInput(false)
      this.$emit('cancel')
    },
    handleConfirm() {
      if (this.confirmDisabled) return
      this.$emit('confirm')
    },
  },
}
</script>
